<template>
    <div class="g pop-up-inner">
        <mdToggleAside
            @sendEvent="close"
        ></mdToggleAside>
        <mdCaption
            :caption="$t('popup.changepwd.caption.changepwd')"
        ></mdCaption>
        <div class="g pop-up-content">
            <div class="g pop-up-content-inner">
                <div class="g">
                    <div class="fieldset">
                        <label>{{ $t('popup.changepwd.item.currentpwd') }}</label>
                        <div class="cp input password" :class="[errors.has('pwd')? 'is-error': '']" :data-error="errors.first('pwd')">
                            <input v-model="result.pwd" type="password" v-validate="'required'" name="pwd" id="pwd">
                        </div>
                    </div>
                    <div class="fieldset">
                        <label>{{ $t('popup.changepwd.item.newpwd') }}</label>
                        <div class="cp input password" :class="[errors.has('newpwd')? 'is-error': '']" :data-error="errors.first('newpwd')">
                            <input v-model="result.newpwd" type="password" v-validate="'required'" name="newpwd" id="newpwd" ref="newpwd">
                        </div>
                    </div>
                    <div class="fieldset">
                        <label>{{ $t('popup.changepwd.item.repeatpwd') }}</label>
                        <div class="cp input password" :class="[errors.has('confirmpwd')? 'is-error': '']" :data-error="errors.first('confirmpwd')">
                            <input v-model="result.confirmpwd" type="password" v-validate="'required|confirmed:newpwd'" name="confirmpwd" id="confirmpwd">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <mdBtnList
            :content="btns"
            :block="true"
            @sendEvent="receiveEvent"
        ></mdBtnList>
    </div>
</template>

<script>
    import mdCaption from '@/components/mdCaption'
    import mdToggleAside from '@/components/mdToggleAside'
    import mdBtnList from '@/components/mdBtnList'

    import { mapMutations } from 'vuex'

    export default {
        components: {
            mdCaption,
            mdToggleAside,
            mdBtnList,
        },
        props: {
            sn: {
                require: true
            },
            content: { //依照模板定義
                require: false,
                default: () => {
                    return {}
                }
            }
        },
        data: function(){

            return {
                result: {
                    pwd: '',
                    newpwd: '',
                    confirmpwd: '',
                }
            }
        },
        computed: {
            btns: function(){

                let $action = {
                        text: this.$t('popup.changepwd.func.changepwd'),
                        themes: 'major',
                        func: 'action',
                    }

                return [
                    $action,
                ]
            },
        },
        methods: {
            ...mapMutations([
                'catchError',
                'pushNotification',
                'changeState',
            ]),
            sendAction: async function(){
                let _url = this.$siteTool.apiUrl({
                        class: 'users',
                        func: 'resetpwd',
                    })

                try {
                    let $response = await this.$http.post(_url, this.result),
                        _token = $response.token;

                    this.changeState({
                        token: _token,
                    });

                    this.pushNotification({
                        type: 'notification',
                        content: {
                            html: this.$t('site.status.updatesucess'),
                            status: 'success'
                        }
                    });

                    this.close();
                    
                }catch(error) {

                    this.catchError({
                        error: error,
                        callback: this.action,
                    });
                }
            },
            action: function(){

                this.$validator.validate().then(result => {
                    if (!result){
                        //啊就沒通過啊
                    }else {
                        this.sendAction();
                    }
                });
            },
            close: function(){
                this.$emit('sendEvent', 'clearPopUp', this.sn);
            }
        }
    }
</script>

<style scoped lang="scss">

    .fieldset {
        padding: $interval-xs 0;

        label {
            display: block;
            margin-bottom: $interval-s;
        }
    }
</style>
